import React, { useCallback } from 'react';
import Flex from "../Flex.js";
import Selector from "../Selector.js";
import Button from "../Button.js";
import Theme from "../Theme.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PER_PAGE_VALUES = [{
  name: '10',
  value: 10
}, {
  name: '25',
  value: 25
}, {
  name: '50',
  value: 50
}, {
  name: '100',
  value: 100
}, {
  name: '200',
  value: 200
}];
export default function TableV2Footer({
  canPreviousPage,
  canNextPage,
  pageOptions,
  pageCount,
  gotoPage,
  nextPage,
  previousPage,
  setPageSize,
  pageIndex,
  pageSize,
  footerClassName,
  paginationNextButtonVariant,
  paginationNextButtonIcon,
  paginationNextButtonText = 'Next',
  paginationPreviousButtonVariant,
  paginationPreviousButtonIcon,
  paginationPreviousButtonText = 'Previous',
  paginationDropdownVariant,
  tableInstance,
  ...rest
}) {
  const onPageSize = useCallback(({
    value
  }) => {
    setPageSize(value);
  }, [setPageSize]);
  const onGotoPage = useCallback(({
    value
  }) => {
    gotoPage(value);
  }, [gotoPage]);
  const {
    t
  } = Theme.I18N.ns('tablev2.TableV2Footer');
  return /*#__PURE__*/_jsxs(Flex, {
    ...rest,
    className: footerClassName,
    justify: "space-between",
    align: "center",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      align: "center",
      children: [/*#__PURE__*/_jsx(Selector, {
        variant: paginationDropdownVariant,
        value: pageSize,
        onChange: onPageSize,
        values: PER_PAGE_VALUES
      }), /*#__PURE__*/_jsx("span", {
        children: t('perPage', 'per page')
      })]
    }), pageCount > 0 && /*#__PURE__*/_jsx("span", {
      children: t('page', {
        pageIndex: pageIndex + 1,
        pageCount
      }, `${pageIndex + 1} of ${pageCount}`)
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      children: [/*#__PURE__*/_jsx(Button, {
        disabled: !canPreviousPage,
        variant: paginationPreviousButtonVariant,
        icon: paginationPreviousButtonIcon,
        onClick: previousPage,
        children: t('paginationPreviousButtonText', paginationPreviousButtonText)
      }), /*#__PURE__*/_jsx(Selector, {
        variant: paginationDropdownVariant,
        value: pageIndex,
        onChange: onGotoPage,
        values: pageOptions
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !canNextPage,
        variant: paginationNextButtonVariant,
        icon: paginationNextButtonIcon,
        onClick: nextPage,
        children: t('paginationNextButtonText', paginationNextButtonText)
      })]
    })]
  });
}